import { notify } from '@app/ui';
import {
  AddAppointmentRequest,
  AddAppointmentForm,
  AddAppointmentFormValue,
  AddAppointmentWidgetProps,
  ADD_APPOINTMENT_FORM_UID,
  useAddAppointmentMutation,
} from '@mod/schedule';
import dayjs from 'dayjs';
import { useCallback } from 'react';

type CustomAddAppointmentRequest = AddAppointmentRequest & {
  careHomeId: string | null;
};

function useSubmit(props: AddAppointmentWidgetProps) {
  const { onClose, onAdded } = props;
  const [add] = useAddAppointmentMutation();

  return useCallback(
    (value: AddAppointmentFormValue) => {
      const {
        visitor,
        reference,
        hostId,
        occurrence: { start, duration, recurrence },
        ...rest
      } = value;
      const period = { start: start.toISOString(), end: start.add(duration.toDuration()).toISOString() };

      const request: CustomAddAppointmentRequest = {
        ...rest,
        appointmentRequestId: props.appointmentRequestId ?? null,
        hostId,
        visitorId: visitor.value,
        referenceId: reference?.value ?? null,
        timeZone: dayjs.tz.default,
        period,
        recurrence: recurrence
          ? {
              mgRecurrence: recurrence,
            }
          : null,
        careHomeId: visitor.careHome?.id ?? null,
      };

      return add(request)
        .unwrap()
        .then((appointmentId) => {
          notify.success.t('appointments.add.added');
          onAdded?.(period, appointmentId);
          onClose();
        });
    },
    [add, onAdded, onClose, props.appointmentRequestId],
  );
}

export function CustomAddAppointmentWidget(props: AddAppointmentWidgetProps) {
  const onSubmit = useSubmit(props);

  return <AddAppointmentForm key={ADD_APPOINTMENT_FORM_UID} onSubmit={onSubmit} {...props} />;
}
